var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.measureTypeData),callback:function ($$v) {_vm.measureTypeData=$$v},expression:"measureTypeData"}},[_c('v-btn',{attrs:{"large":"","value":"distance"}},[_vm._v("\n     Distance\n   ")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","value":"area"}},[_vm._v("\n     Area\n   ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d2b4819","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/measuretool/MeasureTypeChooser.vue
// module id = CD2r
// module chunks = 1